import { Einblenden, Etikett } from './Bausteine'
import { SchaubildKette, SchaubildNetz, SchaubildQualifizierung } from './Schaubilder'
import { themen, themenAbschnitt, type ThemenSymbol } from '@/data/inhalte'

export const SCHAUBILD: Record<ThemenSymbol, () => JSX.Element> = {
  netz: SchaubildNetz,
  kette: SchaubildKette,
  qualifizierung: SchaubildQualifizierung,
}

/** Die drei Diskussionsthemen, je mit einem Waben-Schaubild (keine Nummern - keine Reihenfolge). */
export default function Themen() {
  return (
    <section id="diskussion" className="verlauf-hell py-20 sm:py-28">
      <div className="huelle">
        <Etikett>{themenAbschnitt.etikett}</Etikett>
        <Einblenden>
          <h2 className="mt-10 max-w-[20ch] text-[clamp(32px,4.2vw,54px)] text-konf-nacht">{themenAbschnitt.titel}</h2>
        </Einblenden>
        <ul className="mt-12 grid gap-5 md:grid-cols-3">
          {themen.map((thema, i) => {
            const Schaubild = SCHAUBILD[thema.symbol]
            return (
              <li key={thema.titel}>
                <Einblenden verzoegerung={i * 90} className="h-full">
                  <article className="group flex h-full flex-col rounded-[28px] border border-white bg-white/80 p-2.5 shadow-[0_20px_50px_rgba(0,30,43,.08)] backdrop-blur transition duration-300 hover:-translate-y-1 hover:shadow-[0_30px_60px_rgba(0,30,43,.14)]">
                    <div className="aspect-[16/9] overflow-hidden rounded-[20px] bg-[radial-gradient(120%_100%_at_15%_0%,#03605C_0%,#012A35_55%,#001E2B_100%)]">
                      <Schaubild />
                    </div>
                    <div className="px-4 pb-5 pt-6 sm:px-5">
                      <h3 className="text-[26px] text-konf-nacht">{thema.titel}</h3>
                      <p className="mt-2.5 text-tinte-leise">{thema.text}</p>
                    </div>
                  </article>
                </Einblenden>
              </li>
            )
          })}
        </ul>
      </div>
    </section>
  )
}
